import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Badge, Nav } from 'react-bootstrap';
import { getUsers, getTeam, getuserWallet } from '../../store/slices/user';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import {
    FiMail, FiPhone, FiCalendar, FiShield, FiCheckCircle,
    FiUser, FiHash, FiClock, FiDollarSign, FiGift, FiTrendingUp,
    FiUsers,
} from 'react-icons/fi';
import { FaRupeeSign } from "react-icons/fa";
import { Link } from 'react-router-dom';


const fmt = (val) => (val !== undefined && val !== null && val !== '') ? val : '---';

// date -- >
const fmtDate = (iso) => {
    if (!iso) return '-';
    try {
        return new Date(iso).toLocaleString('en-IN', {
            day: '2-digit', month: 'short', year: 'numeric',
            hour: '2-digit', minute: '2-digit'
        });
    } catch { return '---'; }
};

const TABS = [
    { key: 'account', label: 'User Details', icon: <FiUser size={15} /> },
    { key: 'financial', label: 'Wallet', icon: <FaRupeeSign size={15} /> },
    { key: 'referral', label: 'Team', icon: <FiUsers size={15} /> },
];



function AccountTab({ user }) {


    const cells = [
        {
            key: 'Full Name', val: fmt(user.name), icon: <FiUser size={11} />
        },
        {
            key: 'Email', val: fmt(user.email), icon: <FiMail size={11} />
        },
        {
            key: 'Mobile', val: fmt(user.mobileNumber), icon: <FiPhone size={11} />
        },
        {
            key: 'Role', val: fmt(user.role), icon: <FiShield size={11} />
        },
        {
            key: 'Created', val: fmtDate(user.createdAt), icon: <FiCalendar size={11} />
        },
        {
            key: 'Last Login', val: fmtDate(user.lastLogin), icon: <FiClock size={11} />
        },

        {
            key: 'Status', val: null, icon: <FiCheckCircle size={11} />, render: () => (

                <Badge className={`uvp-badge ${user.status === 'active' ? 'approved' : 'unverified'}`}>

                    {fmt(user.status)}

                </Badge>
            )
        },
        {
            key: 'Verified', val: null, icon: <FiShield size={11} />, render: () => (

                <Badge className={`uvp-badge ${user.isVerified ? 'verified' : 'unverified'}`}>

                    {user.isVerified ? 'Verified' : 'Unverified'}

                </Badge>
            )
        },
        {
            key: 'Approved', val: null, icon: <FiCheckCircle size={11} />, render: () => (

                <Badge className={`uvp-badge ${user.isApproved ? 'approved' : 'unverified'}`}>

                    {user.isApproved ? 'Approved' : 'Pending'}

                </Badge>
            )
        },
        {
            key: 'Active', val: null, icon: <FiShield size={11} />, render: () => (

                <Badge className={`uvp-badge ${user.isActive ? 'verified' : 'unverified'}`}>

                    {user.isActive ? 'Active' : 'Inactive'}

                </Badge>
            )
        },
        { key: 'Referral Code', val: fmt(user.referralCode), icon: <FiHash size={11} /> },
    ];

    return (
        <>
            <div className="uvp-section-head">
                <p className="uvp-section-title">Account Details</p>

            </div>

            <Row className="g-0 px-3 pb-3 pt-1">
                {cells.map((c, i) => (
                    <Col xs={12} sm={6} key={c.key} className={`uvp-detail-cell ${i % 2 === 0 ? 'uvp-cell-odd' : ''}`}>
                        <div className="uvp-detail-key">{c.icon} {c.key}</div>
                        {c.render
                            ? c.render()
                            : <div className={`uvp-detail-val ${c.val === '-' ? 'muted' : ''}`}>{c.val}</div>
                        }
                    </Col>
                ))}
            </Row>
        </>
    );
}


function FinancialTab({ user, wallet, walletTransactions }) {


    const cards = [
        {
            cls: "wallet",
            icon: <FiDollarSign size={20} />,
            val: `₹${fmt(wallet?.availableBalance)}`,
            lbl: "Available Balance",
        },
        {
            cls: "ref",
            icon: <FiGift size={20} />,
            val: `₹${fmt(wallet?.totalEarnings)}`,
            lbl: "Total Credit",
        },
        {
            cls: "earn",
            icon: <FiTrendingUp size={20} />,
            val: `₹${fmt(wallet?.totalDebit)}`,
            lbl: "Total Debit",
        },
    ];

    return (
        <>
            <div className="uvp-section-head">
                <p className="uvp-section-title">Financial Overview</p>

            </div>

            <Row className="g-3 p-3">
                {cards.map((c) => (
                    <Col xs={12} sm={6} lg={4} key={c.lbl}>
                        <div className={`uvp-fin-card ${c.cls}`}>
                            <div className="uvp-fin-icon">{c.icon}</div>
                            <div className="uvp-fin-val">{c.val}</div>
                            <div className="uvp-fin-lbl">{c.lbl}</div>
                        </div>
                    </Col>
                ))}
            </Row>
            <div className="uvp-section-head mt-4">
                <p className="uvp-section-title">Wallet Transactions</p>
            </div>

            <div className="table-responsive p-3">
                <table className="table table-bordered table-hover align-middle mb-0">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Referred User</th>
                            <th>Type</th>
                            <th>Amount</th>
                            <th>Date</th>
                            <th>Status</th>
                        </tr>
                    </thead>

                    <tbody>
                        {walletTransactions?.length > 0 ? (
                            walletTransactions.map((item, index) => (
                                <tr key={item._id}>
                                    <td>{index + 1}</td>

                                    <td>{item.referredUser?.name || "-"}</td>

                                    <td>{item.type}</td>

                                    <td>₹{item.amount}</td>

                                    <td>
                                        {new Date(item.createdAt).toLocaleDateString("en-IN")}
                                    </td>

                                    <td>
                                        <span
                                            className={`badge ${item.status === "COMPLETED"
                                                ? "bg-success"
                                                : item.status === "PENDING"
                                                    ? "bg-warning text-dark"
                                                    : "bg-danger"
                                                }`}
                                        >
                                            {item.status}
                                        </span>
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="6" className="text-center py-3">
                                    No wallet transactions found.
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </>
    );
}

function ReferralTab({ user, team }) {
    const teamLevels = Object.entries(team?.levels || {});

    return (
        <>
            <div className="uvp-section-head mt-0">
                <p className="uvp-section-title">
                    Team Members ({team?.totalTeam || 0})
                </p>
            </div>

            {teamLevels.length === 0 ? (
                <div className="text-center text-muted py-4">
                    No team members found.
                </div>
            ) : (
                teamLevels.map(([level, members]) => (
                    <div key={level} className="mb-4 px-3">
                        <h6 className="fw-bold mb-3">
                            Level {level}
                        </h6>

                        <Row className="g-3">
                            {members.map((member) => (
                                <Col xs={12} md={6} lg={4} key={member.userId}>
                                    <div className="uvp-ref-card">
                                        <div className="uvp-ref-icon-wrap">
                                            <FiUsers size={20} />
                                        </div>

                                        <div className="uvp-ref-info">
                                            <div className="uvp-ref-info-label">
                                                {member.name}
                                            </div>

                                            <div className="uvp-ref-info-val">
                                                {member.referralCode}
                                            </div>

                                            <div className="uvp-ref-info-sub">
                                                Sponsor: {member.parent?.name || "-"}
                                            </div>

                                            <div className="uvp-ref-info-sub">
                                                Team Size: {member.teamSize}
                                            </div>

                                            <div className="uvp-ref-info-sub">
                                                Direct Referrals: {member.directReferrals}
                                            </div>
                                        </div>


                                    </div>
                                </Col>
                            ))}
                        </Row>
                    </div>
                ))
            )}
        </>
    );
}

// main component -- > 
export default function UserViewProfile() {

    const { id } = useParams();
    const dispatch = useDispatch();
    const { users, loading, error } = useSelector((state) => state.user);
    const [teamMembers, setTeamMembers] = useState([]);
    const [activeTab, setActiveTab] = useState('account');
    const [walletData, setWalletData] = useState({
        wallet: {},
        walletTransactions: [],
    });

    useEffect(() => {
        dispatch(getUsers({ id }));

        dispatch(getTeam({ userId: id }))
            .unwrap()
            .then((res) => {
                setTeamMembers(res || []);
            })
            .catch(() => {
                setTeamMembers([]);
            });

        dispatch(getuserWallet({ userId: id }))
            .unwrap()
            .then((res) => {
                console.log("WALLET API =>", res?.data);

                setWalletData({
                    wallet: res?.walletSummary || {},
                    walletTransactions: res?.data || [],
                });
            })
            .catch(() => {
                setWalletData({
                    wallet: {},
                    walletTransactions: [],
                });
            });
    }, [dispatch, id]);
    const user = users?.[0] || [];


    if (loading) {
        return (
            <div className="uvp-wrapper">
                <div className="uvp-center">
                    <div className="uvp-spinner" />
                </div>
            </div>
        );
    }


    if (error || !user) {
        return (
            <div className="uvp-wrapper">
                <div className="uvp-center flex-column gap-3">
                    <FiUser size={40} style={{ color: 'var(--upc-text-soft)' }} />
                    <p style={{ color: 'var(--upc-text-soft)', fontSize: 15 }}>
                        {error ? 'Failed to load user.' : 'User not found.'}
                    </p>
                </div>
            </div>
        );
    }


    const initials = user.name ? user.name.charAt(0).toUpperCase() : '?';
    const isActive = user.isActive;
    const displayName = fmt(user.name);
    const displayRole = fmt(user.role);
    const displayEmail = fmt(user.email);
    const displayMobile = fmt(user.mobileNumber);
    const displayJoined = fmtDate(user.createdAt);
    const displayWallet = `₹${fmt(user.walletBalance)}`;
    const displayEarnings = `₹${fmt(user.totalEarnings)}`;
    const displayRefCode = fmt(user.referralCode);


    const infoRows = [
        { icon: <FiMail size={14} />, label: 'Email', value: displayEmail },
        { icon: <FiPhone size={14} />, label: 'Mobile', value: displayMobile },
        { icon: <FiCalendar size={14} />, label: 'Joined', value: displayJoined },
    ];


    const statPills = [
        { val: displayWallet, lbl: 'Wallet' },
        { val: displayEarnings, lbl: 'Earnings' },
    ];

    return (
        <>

            <div className="breadcrumb-bar mx-1" >
                <div className="container-fluid">
                    <div className="d-flex  flex-row align-items-center justify-content-between gap-2 py-2">

                        <div className="breadcrumb-left d-flex align-items-center flex-wrap">
                            <Link to="/admin/home" className="breadcrumb-link active my-2">
                                Home
                            </Link>

                            <span className="breadcrumb-separator mx-2">
                                <i className="bi bi-chevron-right"></i>
                            </span>

                            <Link to="/admin/users" className="breadcrumb-link active my-2">
                                Users
                            </Link>
                            <span className="breadcrumb-separator mx-2">
                                <i className="bi bi-chevron-right"></i>
                            </span>
                            <span
                                className="breadcrumb-link inactive"

                            >
                                User details
                            </span>


                        </div>

                    </div>
                </div>
            </div >
            <div className="uvp-wrapper">
                <Container fluid className="px-0">
                    <Row className="g-4 align-items-start">


                        <Col xs={12} lg={3}>
                            <div className="uvp-profile-card">


                                <div className="uvp-avatar-wrap">
                                    <div className="uvp-avatar-pulse" />
                                    <div className="uvp-avatar-ring">
                                        <div className="uvp-avatar-inner">
                                            <span className="uvp-avatar-letter">{initials}</span>
                                        </div>
                                    </div>
                                </div>


                                <div className={`uvp-status-badge ${isActive ? 'active' : 'inactive'}`}>
                                    <span className="uvp-status-dot" />
                                    {isActive ? 'Active' : 'Inactive'}
                                </div>

                                <h2 className="uvp-name">{displayName}</h2>
                                <p className="uvp-role">{displayRole}</p>


                                <div className="uvp-info-list w-100">
                                    {infoRows.map((row) => (
                                        <div className="uvp-info-row" key={row.label}>
                                            <span className="uvp-info-icon">{row.icon}</span>
                                            <div>
                                                <div className="uvp-info-label">{row.label}</div>
                                                <div className="uvp-info-value">{row.value}</div>
                                            </div>
                                        </div>
                                    ))}
                                </div>


                                <Row className="g-2 w-100">
                                    {statPills.map((p) => (
                                        <Col xs={6} key={p.lbl}>
                                            <div className="uvp-stat-pill">
                                                <div className="uvp-stat-val">{p.val}</div>
                                                <div className="uvp-stat-lbl">{p.lbl}</div>
                                            </div>
                                        </Col>
                                    ))}
                                </Row>



                            </div>
                        </Col>


                        <Col xs={12} lg={9}>
                            <div className="uvp-tabs-panel">

                                {/* for tab , icons and, name -- >  */}
                                <Nav className="uvp-tab-nav mb-3">

                                    {TABS.map((t) => (
                                        <Nav.Item key={t.key} className="flex-fill">
                                            <button
                                                className={`uvp-tab-btn w-100 ${activeTab === t.key ? 'active' : ''}`}
                                                onClick={() => setActiveTab(t.key)}
                                            >
                                                {t.icon}
                                                <span className="tab-label">{t.label}</span>
                                            </button>
                                        </Nav.Item>
                                    ))}
                                </Nav>

                                {/* Tab content */}
                                <div className="uvp-tab-content">
                                    {activeTab === 'account' && <AccountTab user={user} />}
                                    {activeTab === "financial" && (
                                        <FinancialTab
                                            user={user}
                                            wallet={walletData.wallet}
                                            walletTransactions={walletData.walletTransactions}
                                        />
                                    )}
                                    {activeTab === 'referral' && <ReferralTab user={user} team={teamMembers} />}
                                </div>

                            </div>
                        </Col>

                    </Row>
                </Container>
            </div>
        </>
    );
}